module.exports = __webpack_public_path__ + "img/testimonials2.4471d707.jpg";